import { WidgetXMLInputConfig } from './WidgetAutoXML.js';
/**
 * {@link WidgetXMLInputConfig} for {@link Widget | Widgets} with no parameters.
 *
 * @category XML
 */
export const BareWidgetXMLInputConfig: WidgetXMLInputConfig = [];
